import { render, staticRenderFns } from "./ConfigPage.vue?vue&type=template&id=ecda7e9c"
import script from "./ConfigPage.vue?vue&type=script&lang=js"
export * from "./ConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports